import { RenderCallback } from '@zapier/legacy-components/esm/types';
/*
 Utility component for converting a HOC to a render component.
 Usage:

   const RenderHoc = myHoc(CallChildren);

   <RenderHoc>
     {propFromMyHoc => <div>Hey I got a prop: {propFromMyHoc}</div>}
   </RenderHoc>
*/

type Props = {
  children: RenderCallback;
};

const CallChildren = (props: Props) => {
  const { children } = props;
  return children(props);
};

export default CallChildren;
